import { CatHeading } from '@blocks-react/components/Heading';
import { ProductCardPriceProps } from '../types';

export const ProductCardPrice = ({
  price,
  currency
}: ProductCardPriceProps) => {
  return (
    <>
      <CatHeading variant="label-lg" className="me-1">
        {price}
      </CatHeading>
      <CatHeading variant="footnote">{currency}</CatHeading>
    </>
  );
};
